import React, {useState, useEffect } from 'react';
import { Button, Form, Input, Modal, Select, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';

const { Text, Link } = Typography;

function AddTournamentLocation(props) {
  
    const [form] = Form.useForm();
    const [locationForm] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [isActive,setIsActive] = useState(false);
    const [showFormLoc, setShowFormLoc] = useState(false);
    const [locations, setLocations] = useState([]);
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        if (isActive && locations.length === 0) {
            fetch(api.places().list().href, {
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
              })
            .then(res => res.json())
            .then(
              (result) => {
                setLocations(result.payLoad);
              },
              (error) => {
                // console.warn('AddTournamentLocation error:', error);
              }
            )
        }
    }, [isActive, locations])

    function togglePopover() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function toggleNewLocationForm() {
      if (showFormLoc) {
        setShowFormLoc(false);
      } else {
        setShowFormLoc(true);
      }
    }

    async function handleOk() {
      const hasErrors = await locationForm.validateFields()
      .then(() => {
        return false;
      })
      .catch((error) => {
        console.log(error);
        return true;
      })
      const existingVals = form.getFieldsValue();
      const locationData = {};
      // console.warn('valori recuperati:', existingVals);
      if (typeof existingVals.placeId != "undefined") {
        const existingLoc = form.getFieldsValue();
        // console.warn('existing location selected?', existingLoc)
        setShowFormLoc(false);
        setIsActive(false);
        form.resetFields();
        locationForm.resetFields();
        locationData.id = existingLoc.placeId;
      } else if (!hasErrors) {
        const newLoc = locationForm.getFieldsValue();
        // console.warn('new location created?', newLoc);
        setShowFormLoc(false);
        setIsActive(false);
        form.resetFields();
        locationForm.resetFields();
        // console.warn('utente ha inserito un posto nuovo!');
        locationData.id = 0;
        locationData.name = newLoc.name;
        locationData.address = newLoc.address;
        locationData.latitude = parseFloat(newLoc.latitude);
        locationData.longitude = parseFloat(newLoc.longitude);
      } else {
        alert("There's noting to insert!")
      }

      // console.warn('questi sono i dati da mandare al ws:', locationData);
      if (locationData.placeId !== 'undefined') {
        setConfirmLoading(true);
        const response = await fetch(api.tournaments().addLocation(props.tournamentId).href, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(locationData) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())
        .then((data) => window.location.reload(false))
        .catch((error) => console.error(error))
      }
    }

    function handleCancel() {
      setIsActive(false);
      form.resetFields();
      locationForm.resetFields();
    }

    const opts = locations.map((l) => {
        const fullDesc = `${l.name} - ${l.address}`;
        return (<Select.Option key={l.id} value={l.id}>{fullDesc}</Select.Option>)
    })

    return(
            <div>
            <Modal title="Add Location" open={isActive} onClose={togglePopover} onOk={handleOk} onCancel={handleCancel} confirmLoading={confirmLoading} maskClosable={false} width="75%">
                <Text>Check if the location is already present in database:</Text>
                <Form form={form}>
                    <Form.Item label="Name" name="placeId">
                        <Select 
                            placeholder="Location Name"
                            value={selected}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        >
                            {opts}
                        </Select>
                    </Form.Item>
                </Form>
                <Text>Your location is not already stored in database? </Text><Link onClick={toggleNewLocationForm}>Click here to create a new location</Link>
                { showFormLoc &&
                  <Form form={locationForm}>
                    <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Location name required !' }]}>
                        <Input placeholder="Location Name"/>
                    </Form.Item>
                    <Form.Item label="Address" name="address" rules={[{ required: true, message: 'Location address required!' }]}>
                        <Input placeholder="Location address"/>
                    </Form.Item>
                    <Form.Item label="Latitude" name="latitude" rules={[{ required: true, message: 'Location Coordinates required!' }]}>
                        <Input placeholder="Latitude" />
                    </Form.Item>
                    <Form.Item label="Longitude" name="longitude" rules={[{ required: true, message: 'Location Coordinates required!' }]}>
                        <Input placeholder="Longitude" />
                    </Form.Item>
                  </Form>
                }
            </Modal>
            <Button style={{ marginTop: 16 }} type="primary" icon={<PlusOutlined />} onClick={togglePopover} >
              ADD LOCATION
            </Button>
            </div>
    );
}

export default AddTournamentLocation;